const formatter = Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
});
export const jobs = [
  {
    id: "1",
    job_title: "General Labour",
    duties:
      "General labour job, load and unload truck, hang poultry to production line, remove feathers of poultry, singe and wash poultry, clean and sanitized production line and general area. Etc",
    salary: `${formatter.format(14)} /hr`,
    postedByName: "Michael M Khan",
    workType: "full time or permanent",
    workSetting: "Grand Valley plant",
    workStatus: "On going hiring",
    requirement: "No",
    date: "Dec 2 2019",
  },
  {
    id: "2",
    job_title: "Wholesale butcher",
    duties:
      "Cut, trim, prepare standard cuts of meat, poultry; Prepare special displays of meat, poultry; Shape,lace and tie meats, poultry; Grind and slice meats using powered grinders & slicing machine; slicing machines; Manage inventory, keep records of sales and determine amount, product line and freshness of products per company and customer requirements; Ensure food storage conditions are adequate.",
    salary: `${formatter.format(18)} /hr`,
    postedByName: "Michael M Khan",
    workType: "full time or permanent",
    workSetting: "Sheik Halal Farm Grand Valley plant",
    workStatus: "Closed Oct 24,2020",
    requirement:
      "ASAP. High school Ed required. 3+ yrs experience. Must be able to process meat per Halal requirement.",
    date: "Sep 1 2020",
  },
  {
    id: "3",
    job_title: "Industrial butcher",
    duties:
      "Slaughter livestock using knives as prescribed by Islamic law; Skin, clean and trim carcasses;Remove viscera and other inedible parts from carcasses; Split carcasses into smaller portions to facilitate handling; Remove bones from meat; Cut meat and poultry into specific cuts for institutional, commercial or other wholesale use; Remove skin, excess fat, bruises or other meat portion; Slaughter poultry and remove inedible parts; Remove feathers and singe and wash poultry to prepare for further processing or packaging;",
    salary: `${formatter.format(18)} /hr`,
    postedByName: "Michael M Khan",
    workType: "full time or permanent",
    workSetting: "Grand Valley plant",
    workStatus: "Open until Dec 31,2020",
    requirement:
      "ASAP. High school Ed required. 3to 5 years experience. Must be able to process meat per Halal requirement.",
    date: "Sep 1 2020",
  },
];
